import { Component } from '@angular/core';
import { ReferenceDataLabels } from 'rome-library';

@Component({
  selector: 'boi-unsupported-device',
  templateUrl: './unsupported-device.page.html'
})
export class UnsupportedDevicePage {
  public readonly referenceDataLabels = ReferenceDataLabels;
}
